<template>
	<v-card class="ma-2 mb-4">
		<v-toolbar color="teal" dark>
			<v-toolbar-title>
				<v-icon class="mr-3">business</v-icon>
				Projekty opiekuna
			</v-toolbar-title>
			<v-spacer/>
		</v-toolbar>

		<SupervisedProjectsTable/>

		<SupervisedAgencyProjectsTable/>
	</v-card>
</template>

<script>
	import SupervisedProjectsTable from "./components/SupervisedProjectsTable";
	import SupervisedAgencyProjectsTable from "./components/SupervisedAgencyProjectsTable";

	export default {
		name: "SupervisedProjectsView",
		components: {SupervisedAgencyProjectsTable, SupervisedProjectsTable},
	};
</script>

<style scoped>

</style>